// extracted by mini-css-extract-plugin
module.exports = {"cardTopics":"review_cardTopics__1tF2c","cardValues":"review_cardValues__3RjFS","subTopicDivider":"review_subTopicDivider__1bKeU"};